<template>
<div>
	<!-- PLACES INPUT -->
	<div class="" v-if="placesAddress">
		<h2 class="login-title">{{ titleStage1 }}</h2>

		<google-places-input v-on:googlePlacesUpdated="googlePlacesUpdated" placeholder="Type '28 Street name'"></google-places-input>
		<a @click.prevent="changeStage">Enter address manually</a>

		<div class="btn-back">
			<a href="#" class="login__link" @click.prevent="changeStage">&lt; back</a>
		</div>
	</div>

	<!-- MANUAL ADDRESS -->
	<div class="address-stage__manual-address" v-if="!placesAddress">
		<h2 class="login-title">{{ titleStage2 }}</h2>

		<address-input v-model="address" @notFullPostcode="isNotFullPostcode = arguments[0]"></address-input>

		<button href="" class="mdc-button mdc-button--raised event-box__link" :disabled="isNotFullPostcode" @click.prevent="goNext">{{ buttonLabel }}</button>

		<p>
			<a @click.prevent="changeStage">Find your address</a>
		</p>

		<div class="btn-back login__back--relative">
			<a href="#" class="login__link" @click.prevent="goBack">&lt; back</a>
		</div>
	</div>
</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import vModelNested from '@/libs/vModelNested.js';
import GooglePlacesInput    from '../components/GooglePlacesInput.vue';
import AddressInput from '../components/AddressInput.vue';

export default {
	 props: {
		 value: Object,
		 buttonLabel: {
			 type: String,
			 default: 'Next'
		 },
		 titleStage1: {
			 type: String,
			 default: 'Please enter your address'
		 },
		 titleStage2: {
			 type: String,
			 default: 'Confirm your address'
		 }
	 },
    data: function() {
        return {
					placesAddress: true,
					isNotFullPostcode: false
        }
    },
    components: {
        'google-places-input':      GooglePlacesInput,
		  	'address-input': 				AddressInput
    },
		computed: {
				address: vModelNested,
		},
    methods: {
        googlePlacesUpdated: function(place) {
            this.$emit('googlePlacesUpdated', place);
				if(place.street === '' || place.postcode === '') {
                return;
            } else {
					this.changeStage()
				}
        },
        latLngGenerated: function(location) {
            this.lat = location.lat();
            this.lng = location.lng();
        },
		  changeStage: function() {
			  this.placesAddress = !this.placesAddress;
		  },
		  emitAddress: function(){
			   this.address.addressNotEmpty = this.addressNotEmpty;
			   this.address.fullAddress = this.fullAddress;
			   this.$emit('input', this.address);
		  },
		  goBack: function() {
			  this.$emit('back');
		  },
		  goNext: function(){
			  this.$emit('next');
		  }
    },
	 watch: {
		  address: {
				handler: function () {
				  this.emitAddress();
				},
				deep: true
		  }
	 }
}
</script>



// WEBPACK FOOTER //
// src/components/AddressStage.vue